const listInput = {
  /**
   * Initialize the events and variables
   * @param  {String} group Name of the current group
   * @return {void}
   */
  create(node, props) {
    this.group = node;

    this.inputName = props.inputName;

    this.list = this.getElementForGroup('.js-list-input__list');
    this.listItems = this.getElementsForGroup('.js-list-input__list-item');
    this.add = this.getElementForGroup('.js-list-input__control-add');
    this.deleteButtons = this.getElementsForGroup('.js-list-input__list-item-delete');

    if (!this.listItems.length) {
      this.addInput();
    }

    this.add.addEventListener('click', () => {
      this.addInput();
    });

    this.deleteButtons.forEach(deleteButton => this.addEventListenerToDeleteButton(deleteButton));
  },

  addInput() {
    const listItemWrapper = document.createElement('div');
    const listItemInput = document.createElement('input');
    const listItemDelete = document.createElement('button');

    listItemWrapper.classList = 'js-list-input__list-item';

    listItemInput.setAttribute('name', this.inputName);
    listItemInput.setAttribute('id', this.inputName);
    listItemInput.setAttribute('type', 'text');
    listItemInput.classList = 'form-control form-control-sm w-50';

    listItemDelete.setAttribute('type', 'button');
    listItemDelete.classList = 'js-list-input__list-item-delete btn btn-sm btn-danger';
    listItemDelete.innerText = 'x';

    this.addEventListenerToDeleteButton(listItemDelete);

    listItemWrapper.appendChild(listItemInput);
    listItemWrapper.appendChild(listItemDelete);

    this.list.appendChild(listItemWrapper);
  },

  addEventListenerToDeleteButton(button) {
    button.addEventListener('click', (e) => {
      e.target.parentElement.remove();
    });
  },

  /**
   * Get element from the same group with a classname
   * @param  {String} cls Class name to get the element for
   * @return {Node}       Element
   */
  getElementForGroup(cls) {
    return this.group.querySelector(cls);
  },

  /**
   * Get elements from the same group with a classname
   * @param  {String} cls Class name to get the element for
   * @return {Node}       Element
   */
  getElementsForGroup(cls) {
    return this.group.querySelectorAll(cls);
  },
};

export default listInput;
